import { SVGAttributes } from 'react'

export type SVGIconProps = SVGAttributes<SVGSVGElement> & { symbol?: string }

const SVGIcon = ({ symbol, ...props }: SVGIconProps) => {
  return (
    <svg {...props}>
      <use xlinkHref={`#${symbol}`} />
    </svg>
  )
}

export default SVGIcon
